import IconProps from "assets/icon/payment-method/iconProps"
import { colors } from "constants/theme"

export default function Wallet(props: IconProps) {
    return (
        <svg data-name="Group 8596" xmlns="https://www.w3.org/2000/svgg" width="62" height="40" viewBox="0 0 73 40">
            <g data-name="Rectangle 3857" style={{ fill: colors.transparent, stroke: props.active || '#9e9e9e', strokeWidth: '2px' }}>
                <rect width="73" height="40" rx="4" style={{ stroke: 'none' }} />
                <rect x="1" y="1" width="71" height="38" rx="3" style={{ fill: 'none' }} />
            </g>
            <path data-name="Icon wallet" d="M12 6H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM4 8h8v2H4V8zm8 12H4v-8h8v8zm-2-6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" transform="translate(29 8)" style={{ fill: props.active || '#9e9e9e' }} />
        </svg>
    )
}
